export default __webpack_public_path__ + "static/media/dt_control.9d58abb5.svg";